import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusBaseErrorFragmentDoc } from './BaseError.generated'
import * as Types from './purchasePlus_graphql'

export const CreateBuyListProductDocument = gql`
  mutation CreateBuyListProduct($input: CreateBuyListProductInput!) {
    createBuyListProduct(input: $input) {
      buyListProduct {
        id
        product {
          id
        }
      }
      errors {
        ...PurchasePlusBaseError
      }
    }
  }
  ${PurchasePlusBaseErrorFragmentDoc}
` as unknown as DocumentNode<Types.CreateBuyListProductMutation, Types.CreateBuyListProductMutationVariables>
